import React from 'react'
import { useParams } from 'react-router-dom'

const ProjectDetail = () => {
  const { id } = useParams()
  
  return (
    <div className="container">
      <h1>Project: {id}</h1>
      <p>Project detail page content coming soon...</p>
    </div>
  )
}

export default ProjectDetail